import React from 'react';

export const ModalBody = ({ children }: { children: React.ReactNode }) => (
  <div id="modal-body" className="h-full p-6">
    {children}
  </div>
);
